const shared = {
  sizes: {
    drawerWidth: 236,
  },
};

export default shared;
